<template>
  <section class="cta-section">
    <p class="cta-section__text" v-if="content.text">
      {{ content.text }}
    </p>
    <button class="cta-section__button" @click="scrollToTimeline">
      <p class="cta-section__button__label">{{ content.cta.label }}</p>
      <icon
        :data="pageIcons[content.cta.icon]"
        class="cta-section__button__icon"
      ></icon>
    </button>
  </section>
</template>

<script setup>
import { pageIcons } from "../../plugins/page-icons";

defineProps({
  content: Object,
});

const scrollToTimeline = () => {
  return document
    .getElementById("InfoSection")
    .scrollIntoView({ behavior: "smooth" });
};
</script>

<style lang="scss" scoped>
.cta-section {
  padding: 0 23.81vw;
  border-bottom: 1px solid $scala-grigi-gray_2;
  text-align: left;
  position: relative;

  &__text {
    border-left: 1px solid $scala-grigi-gray_2;
    border-right: 1px solid $scala-grigi-gray_2;
    padding: 17.2vh 14.749vw 14.15vh 14.749vw;
    color: $scala-grigi-gray_1;
    @include p-l-light;
  }

  &__button {
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    text-transform: uppercase;
    padding: toRem(17.5) toRem(50);
    background: $scala-grigi-white;
    border-radius: toRem(20);
    @include bottom-shadow-timeline;
    @include link-l;
    transition: background .5s ease;

    &__icon {
      min-height: 1.5rem;
      min-width: 1.5rem;
      margin-left: toRem(10);
    }
    &:hover {
      background: $primary-yellow;
    }
  }
}

.tablet,
.mobile {
  .cta-section {
    padding: 0;
    border-bottom: none;
    border-top: 1px solid $scala-grigi-gray_2;

    &__text {
      border: none;
      padding: 10.29vh 18.359vw 13.49vh 18.359vw;
    }

    &__button {
      top: -25px;
      padding: toRem(12.5) toRem(40);
    }
  }
}

.mobile {
  .cta-section {
    border-top: none;

    &__text {
      border: none;
      padding: 13.74vh 6.667vw 13.15vh 6.667vw;
    }

    &__button {
      top: -25px;
      padding: toRem(12.5) toRem(40);
      white-space: nowrap;
    }
  }
}
</style>
